<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：订单列表
  -->
  <div class="user">
    <div style="margin-bottom: 15px;">
      <el-button type="success" @click="shuaixn">刷新</el-button>
    </div>

    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <!-- <el-form-item label="会员信息">
            <el-input v-model="searchForm.search" placeholder="请输入昵称|手机号|ID"></el-input>
          </el-form-item> -->
        <!-- <el-form-item label="订单号"><el-input size="small" v-model="searchForm.order_no"
              placeholder="请输入订单号"></el-input></el-form-item>  -->

        <el-form-item label="姓名"><el-input size="small" v-model="searchForm.user_name"
            placeholder="请输入姓名"></el-input></el-form-item>

        <el-form-item label="手机号"><el-input size="small" v-model="searchForm.mobile"
            placeholder="请输入手机号"></el-input></el-form-item>

        <el-form-item label="身份证"><el-input size="small" v-model="searchForm.usernum"
            placeholder="请输入身份证"></el-input></el-form-item>

        <el-form-item label="用户id"><el-input size="small" v-model="searchForm.user_id"
            placeholder="请输入用户id"></el-input></el-form-item>
        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker size="small" v-model="searchForm.create_time" type="daterange" value-format="yyyy-MM-dd"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item><el-button size="small" type="primary" icon="el-icon-search"
            @click="onSubmit">查询</el-button></el-form-item>
        <!-- <el-form-item><el-button size="small" type="success" @click="onExport">导出</el-button></el-form-item> -->
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <template>
        <el-table :data="tabledata" style="width: 100%" height="570">
          <el-table-column label="姓名">
            <template slot-scope="scope">
              <div v-if="scope.row.user_name">
                {{ scope.row.user_name }}
              </div>
              <div v-else>
                null
              </div>

            </template>
          </el-table-column>
          <el-table-column prop="user_id" label="用户id"></el-table-column>
          <el-table-column prop="process_status" width="200" label="状态值"> </el-table-column>
          <el-table-column prop="tips" width="200" label="提示"> </el-table-column>
          <el-table-column prop="external_user_id" width="300" label="外部用户id"></el-table-column>
          <el-table-column prop="external_order_number" width="160" label="外部订单号"> </el-table-column>
          <el-table-column prop="organization_id" width="150" label="机构id"> </el-table-column>
          <el-table-column prop="signature_id" label="签署id"> </el-table-column>
          <el-table-column prop="reminder_status_id" label="提醒状态id"> </el-table-column>
          <el-table-column prop="secret_key" label="秘钥"> </el-table-column>
          <el-table-column prop="sign" width="300" label="sign"></el-table-column>
          <el-table-column prop="msg_id" width="300" label="msg_id"></el-table-column>
          <el-table-column prop="return_type" width="150" label="类型"></el-table-column>
          <el-table-column prop="withholding_status" label="代扣状态"></el-table-column>
          <el-table-column label="应代扣时间" width="200">
            <template slot-scope="scope">
              <div v-if="scope.row.withholding_time">
                {{ scope.row.withholding_time | formatDate }}
              </div>
              <div v-else>
                -
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="withholding_amount" label="应代扣金额"></el-table-column>
          <el-table-column prop="alipay_transaction_number" width="300" label="支付宝交易号"></el-table-column>
          <el-table-column prop="payee_agent_user_id" width="150" label="收款方代理用户id"></el-table-column>
          <el-table-column prop="withholding_execution_order_number" width="300" label="代扣执行订单号"></el-table-column>
          <el-table-column prop="withholding_and_deposit_transaction_id" width="300" label="代扣存证事务id"></el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button @click="lookClick(scope.row)" v-if="scope.row.process_status == '用户投诉变更通知'" type="text"
                size="small">查看</el-button>
              <el-button @click="fkClick(scope.row)" v-if="scope.row.process_status == '用户投诉变更通知'" type="text"
                size="small">反馈</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>

      <!-- 查看投诉 -->
      <el-dialog title="投诉详情" :visible.sync="dialogVisiblets" width="30%">
        <div style="text-align:center;">
          <h1>{{ user_name }}</h1>
        </div>
        <div class="tslist">
          <div>用户诉求: {{ feedbacklist.leafCategoryName }}</div>
          <div>申诉原因: {{ feedbacklist.complainReason }}</div>
          <div>用户描述: {{ feedbacklist.content }}</div>
          <div>提交时间: {{ feedbacklist.gmtCreate }}</div>
          <div>投诉单号: {{ feedbacklist.complainEventId }}</div>
          <div>订单单号: {{ feedbacklist.tradeNo }}</div>
          <div style="display:flex;"> <span style="margin-right: 5px;">图片凭证: </span> 
            <img v-if="feedbacklist.images" style="width:100px;height: 100px;" :src="feedbacklist.images[0]"> 
          </div>
        </div>
      </el-dialog>

      <!-- 反馈 -->
      <el-dialog title="反馈客户" :visible.sync="dialogVisiblefk" width="30%">
        
        <el-input v-model="fkinput" placeholder="请输入反馈内容"></el-input>

        <el-select v-model="fbCode" placeholder="请选择反馈类型" style="margin-top: 10px;">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
      </el-select>

        <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisiblefk = false">取 消</el-button>
        <el-button type="primary" @click="confirm()">确 定</el-button>
      </span>
      </el-dialog>
    

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
          :current-page="curPage" :page-sizes="[10, 20, 50, 100]" :page-size="10"
          layout="total, prev,sizes ,pager, next, jumper" :total="totalDataNumber"></el-pagination>
      </div>
    </div>
    <Logistics :logisticsData="logisticsData" :isLogistics="isLogistics" @closeDialog="closeLogistics">
    </Logistics>
  </div>
</template>

<script>
import OrderApi from "@/api/order.js";
import { timeFormat } from "@/utils/timeFormat";
import Logistics from "@/components/logistics/viewLogistics.vue";
import qs from "qs";
export default {
  name: "Login",
  components: {
    Logistics,
  },
  data() {
    return {
      xing: "",
      dialogTableVisible: false,
      jieguo: "",
      tabledata: [],
      user_id: "",
      // 输入框值
      yushou: "",
      // 租期id
      shneheList: [],
      // 租期列表
      zqlist: "",
      /*显示弹框*/
      dialogVisible: false,
      dialogVisiblets: false,
      dialogVisiblefk: false,
      /*切换菜单*/
      activeName: "all",
      /*是否加载完成*/
      loading: true,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        user_id: "",
        user_name: "",
        usernum: "",
        mobile: "",
        search: '',
        order_no: '',
        style_id: '',
        create_time: ''
      },
      /*反馈信息*/
      feedbacklist: [],
      /*时间*/
      create_time: "",
      create_time1: "",
      isLogistics: false,
      logisticsData: {},
      user_name: "",
      number:"",
      fkinput:"",
      fbCode:"",
      options: [{
          value: '00',
          label: '使用体验保障金退款'
        }, {
          value: '02',
          label: '通过其他方式退款'
        }, {
          value: '03',
          label: '已发货'
        }, {
          value: '04',
          label: '其他'
        }, {
          value: '05',
          label: '已完成售后服务'
        }, {
          value: '06',
          label: '非非我方责任范围'
        }],
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    // 反馈客户确认
    confirm() {
      let data = {
        complainEventId:this.number,
        content:this.fkinput,
        feedbackCode:this.fbCode,
      }
      OrderApi.tsfk(data, true).then((res) => {
          this.dialogVisiblefk = false;
        }).catch((res) =>{
          this.dialogVisiblefk = false;
        })
    },
    // 反馈
    fkClick(row) {
      console.log(row.alipay_transaction_number);
      this.dialogVisiblefk = true;
      this.number = row.alipay_transaction_number;
    },
    // 查看
    lookClick(row) {
      console.log(row.process_status, row);
      this.dialogVisiblets = true;
      OrderApi.tsddcx({ complainEventId: row.alipay_transaction_number }, true)
        .then((data) => {
          console.log(data);
          this.feedbacklist = data.data;
        })
    },
    // 刷新
    shuaixn() {
      this.loading = true;
      this.getData();
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = this.searchForm;
      Params.dataType = self.activeName;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      OrderApi.mayiliandaikouhui(Params, true)
        .then((data) => {
          self.loading = false;
          self.tabledata = data.data.list.data;
          // console.log("data", self.tabledata);
          self.totalDataNumber = data.data.list.total;
          for (let i = 0; i < self.tabledata.length; i++) {
            let item = self.tabledata[i]
            // console.log("res", item.withholding_time)
            if (item.withholding_time = "") {
              item.withholding_time = '无'
            } else {
              let date = new Date(item.withholding_time);
              //时间戳为10位需*1000，时间戳为13位的话不需乘1000
              let y = date.getFullYear();
              let MM = date.getMonth() + 1;
              MM = MM < 10 ? ('0' + MM) : MM; //月补0
              let d = date.getDate();
              d = d < 10 ? ('0' + d) : d; //天补0
              let h = date.getHours();
              h = h < 10 ? ('0' + h) : h; //小时补0
              let m = date.getMinutes();
              m = m < 10 ? ('0' + m) : m; //分钟补0
              let s = date.getSeconds();
              s = s < 10 ? ('0' + s) : s; //秒补0
              shijian = y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
              // console.log(shijian)
            }
          }
        })
        .catch((error) => { });
    },

    openLogistics() {
      this.isLogistics = true;
    },
    closeLogistics() {
      this.isLogistics = false;
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    },
    onExport: function () {
      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/order.operate/export?' + qs.stringify(this.searchForm);
    }
  },
  filters: {
    // 过滤器
    formatDate(create_time1) {
      let date = new Date(create_time1 * 1);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? "0" + d : d; //天补0
      let h = date.getHours();
      h = h < 10 ? "0" + h : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s; //秒补0
      // return y + '-' + MM + '-' + d; //年月日
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s; //年月日时分秒
    },
  },
};
</script>
<style lang="scss">
.tslist {
  div {
    margin: 7px;
  }
}

.d1 {
  width: 100px;
  list-style: none;
  border: 1px solid #ffa49f;
  padding: 5px;
  background-color: #fff1f0;
  color: #f6363e;
  border-radius: 10px;
  text-align: center;
  margin: 25px 0;
}

.anniu {
  margin-bottom: 2px;
}

.product-info {
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}

.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}

.order-code .state-text-red {
  background: red;
}

.table-wrap .product-info:first-of-type {
  border-top: none;
}

.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}

.qianshu {
  font-size: 20px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/mayilian/mayilian/listfeedback.vue